import type { FC } from "react";
import { ManagementModal } from "app/pages/sales-intelligence/common-components/modals/ManagementModal/ManagementModal";
import { getCrmName } from "app/pages/sales-intelligence/utils/crm";
import { getIntegrationNameFromUrl } from "app/pages/sales-intelligence/common-components/export-table/getIntegrationNameFromUrl";
import { translate } from "app/filters/i18nFilter";
import { modalStyles, detailsStyles } from "./styles";
import type { Integration } from "app/pages/sales-intelligence/sub-modules/management/types";

type ConfirmDisableModalProps = {
    isOpen: boolean;
    onCancel(): void;
    onConfirm(): void;
};

export const ConfirmDisableModal: FC<ConfirmDisableModalProps> = (props) => {
    const { integrationName: crm } = getIntegrationNameFromUrl();
    const crmName = getCrmName(crm as Integration);

    return (
        <ManagementModal
            customStyles={modalStyles}
            customDetailsStyles={detailsStyles}
            onConfirm={props.onConfirm}
            onClose={props.onCancel}
            isOpen={props.isOpen}
            title={translate("si.manage-integration.crm-sync.modal.title", { crmName })}
            details={translate("si.manage-integration.crm-sync.modal.details", { crmName })}
            confirmBtnText={translate("si.manage-integration.crm-sync.modal.confirm")}
            confirmBtnType="warning"
            cancelBtnText="si.common.button.cancel"
            cancelBtnType="flatDark"
        />
    );
};
